import axios, { AxiosError, AxiosResponse } from "axios";
import { IBrand } from "../../Models/IBrand";
import { authorizedAxios } from "../../Actions/AxiosActions";
import { IGPSServiceAxios } from "../IGPSServiceAxios";
import { IBrandCategory } from "../../Models/IBrandCategory";

export class GPSServiceAxios implements IGPSServiceAxios {
    public GetBrands(): Promise<IBrand[]> {
        return new Promise<IBrand[]>((resolve, reject) => {
            authorizedAxios("GET", "/services/gps/Brand/")
                .then((response: IBrand[]) => {
                    resolve(response);
                })
                .catch((error: AxiosError) => {
                    reject(error);
                });
        });
    }

    public GetCategories(): Promise<IBrandCategory[]> {
        return new Promise<IBrandCategory[]>((resolve, reject) => {
            /** GB:
       * This may need to be accessed via share (i.e. when there is no user logged in) .
       * So, this call does not need authorization.
       */
            axios
                .get("/services/gps/Category")
                .then((response: AxiosResponse) => {
                    resolve(response.data);
                })
                .catch((error: AxiosError) => {
                    reject(error);
                });
        });
    }

    public GetBrandById(brandId: string): Promise<IBrand> {
        return new Promise<IBrand>((resolve, reject) => {
            authorizedAxios("GET", `/services/gps/Brand/${brandId}`)
                .then((brand: IBrand) => {
                    resolve(brand);
                })
                .catch((error: AxiosError) => {
                    reject(error);
                });
        });
    }
}
